import { ReactComponent as Bulldozer } from 'assets/bulldozer.svg'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'
import MmRating from 'components/MmRating'

const PlaceElement = ({ showButton = false, isDesktop, idx, data, customRedirect = '', scrollMenu = undefined, warehouseTypeId }) => {
  const { id, mm_score, mm_score_info, automation, place_attrs, city, street, estateNumber, localNumber, sizes, photos, constructionDate } = data || {}
  const [activeSize, setActiveSize] = useState(null)

  const { push, replace } = useHistory()
  const { t } = useTranslation('map')

  useEffect(() => {
    if (sizes && sizes.length > 0) {
      const newSize = warehouseTypeId
        ? (sizes.find(s => s.warehouseTypeId === warehouseTypeId) || sizes[0])
        : sizes[0]
      setActiveSize(newSize)
    }
  }, [sizes, warehouseTypeId])

  const handleGo = () => {
    if (idx !== undefined) replace(`${window.location.pathname}?from=mag_${idx}`)
    push(customRedirect ? `${customRedirect}?warehouseTypeId=${activeSize.warehouseTypeId}` : `/map/${id}`)
  }

  const showPopup = (popup) => {
    push(window.location.pathname, LOCATION_STATES.popup(popup))
  }

  return (
    <div
      className="placeElement"
      onScroll={scrollMenu}
      onClick={() => {
        if (isDesktop && !showButton) handleGo()
      }}>
      {isDesktop && (
        <div className="placeElement__mainImg">
          {photos && photos.length > 0 ? (
            <img src={photos[0]?.public_path} alt="" />
          ) : (
            <span className="noImg">Brak zdjęć</span>
          )}
          {constructionDate && <div className='placeElement__construction'>
            <div className='placeElement__construction__top center'>
              <Bulldozer />
              <div>{t('theYardIsUnderConstruction')}</div>
            </div>
            <div className='placeElement__construction__bottom'>{t('availableFrom')} {constructionDate}</div>
          </div>}
        </div>
      )}

      <div className="placeElement__name">
        <h2>
          {city}, {street} {localNumber} {estateNumber}
        </h2>
        {typeof mm_score === 'number' && <MmRating
          number={mm_score}
          action={(e) => {
            e.stopPropagation() // Zatrzymuje propagację kliknięcia
            showPopup({ type: "mm_score", scoreInfo: mm_score_info })
          }}
        />}
      </div>

      <div
        className='placeElement__automation'
        onClick={(e) => {
          e.stopPropagation()
          showPopup({ type: "automation", automation })
        }}>
        <div className={automation.key === 'full-automatic' ? 'green' : undefined}>
          {(automation.key === 'full-automatic' || automation.key === 'semi-automatic') && <i className='icon icon--shield' />}
          <span>{automation.title}</span>
        </div>
        <div>{automation.description}</div>
      </div>

      <div
        className="placeElement__attr"
        onClick={(e) => {
          e.stopPropagation() // Zatrzymuje propagację kliknięcia
          showPopup({ type: "warehouse_attr", place_attrs })
        }}
      >
        {place_attrs.map((item) => (
          <div key={item.id} className="placeElement__attr__item">
            <i className={`icon icon--check`}></i>
            <span>{item.name}</span>
          </div>
        ))}
      </div>

      {!isDesktop && (
        <div
          className="placeElement__automation"
          onClick={(e) => {
            e.stopPropagation() // Zatrzymuje propagację kliknięcia
            showPopup("automation")
          }}
        >
          <div>
            {automation.key === "full-automatic" ? (
              <i className="icon icon--shield"></i>
            ) : (
              ""
            )}
            <span className={automation.key === "full-automatic" ? "green" : undefined}>
              {automation.title}
            </span>
          </div>
          <div>{automation.description}</div>
        </div>
      )}

      <div className="placeElement__sizes">
        <span className="subtitle">{t('availableSizes')}</span>
        {sizes.map((item, idx) => (
          <div
            key={idx}
            className={`sizeItem${item.warehouseTypeId === (activeSize && activeSize.warehouseTypeId) ? " active" : ""}`}
            onClick={(e) => {
              e.stopPropagation() // Zatrzymuje propagację kliknięcia
              setActiveSize(item)
            }}
          >
            {item.size} m<sup>2</sup>
          </div>
        ))}
      </div>

      <div className="placeElement__price">
        <span className="subtitle">{t('costOfSelectedSize')}</span>
        <span className="--secFont">{t('from')} {activeSize?.monthlyGrossPrice}</span>
        <span className="--secFont small">/ {t('monthly')}</span>
        {!isDesktop && (
          <div
            className="buttonGo"
            onClick={(e) => {
              e.stopPropagation() // Zatrzymuje propagację kliknięcia
              handleGo()
            }}>
            <i className="icon icon--arrow-right s24"></i>
          </div>
        )}
      </div>

      {showButton && <div className='placeElement__footer'>
        <ArrowBtn
          text={t('selectWarehouse')}
          action={handleGo}
        />
      </div>}
    </div>
  )
}

export default PlaceElement